import DataPersist from 'utils/dataPersist/dataPersist';

const sourcesStorage = new DataPersist('sourcesStorage', 'localStorage');

export default sourcesStorage;
